import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class AvisosService {
  
  constructor(private http: HttpClient) {
  
  }

  public ListarNaoLidos(): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/ListarNaoLidos`);
  }

  public ListarHistorico(codAviTipo: number, filtroMural: string, numItens: number, numPagina: number): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/ListarHistorico`, {params: {codAviTipo: codAviTipo, filtroMural: filtroMural, numItens: numItens, numPagina: numPagina}} as any);
  }

  public CarregarAvisoSemAceite(): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/CarregarAvisoSemAceite`);
  }

  public GravarAceite(codAviAviso: number): Observable<any> {

    return this.http
                .post(`${environment.apiURL}/Logado/Avisos/GravarAceite?codAviAviso=${codAviAviso}`, {});
  }

  public MarcarComoLido(codAviAviso: number): Observable<any> {

    return this.http
                .post(`${environment.apiURL}/Logado/Avisos/MarcarComoLido?codAviAviso=${codAviAviso}`, {});
  }

  public ListarArquivos(codArqGrupo: number): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/ListarArquivos`, {params: {codArqGrupo: codArqGrupo}} as any);
  }

  public DownloadArquivo(hashCodArquivo: any){

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/DownloadArquivo?hashCodArquivo=${hashCodArquivo}`, {responseType: "blob"})
  }

  public ListarTipos(filtroMural: string): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Logado/Avisos/ListarTipos`, {params: {filtroMural: filtroMural}});
  }
}
